import { Locale } from '@finxone-platform/shared/enums';
import { AlertTypes, NotificationTemplateEnum } from '@finxone-platform/shared/sys-config-types';

export const profileInAppTranslations = {
  [Locale.en_GB]: {
    INDIVIDUAL_PROFILE_UPDATE_TITLE: 'Personal Profile Updated',
    INDIVIDUAL_PROFILE_UPDATE_DESCRIPTION: 'Personal details updated successfully. ',
    BUSINESS_PROFILE_UPDATE_TITLE: 'Your business profile details were updated',
    BUSINESS_PROFILE_UPDATE_DESCRIPTION: 'View the notification for more details',
  },
  // Add more locales as needed
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const generateProfileInAppAlerts = (translations: any) => ({
  [NotificationTemplateEnum.INDIVIDUAL_PROFILE_UPDATE]: {
    name: 'Individual Profile Update',
    type: AlertTypes.INFO,
    title: translations.INDIVIDUAL_PROFILE_UPDATE_TITLE,
    description: translations.INDIVIDUAL_PROFILE_UPDATE_DESCRIPTION,
  },
  [NotificationTemplateEnum.BUSINESS_PROFILE_UPDATE]: {
    name: 'Business Profile Update',
    type: AlertTypes.INFO,
    title: translations.BUSINESS_PROFILE_UPDATE_TITLE,
    description: translations.BUSINESS_PROFILE_UPDATE_DESCRIPTION,
  },
});
